import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { Initials } from '#/components/Initials/Initials';

type Props = {
  width: number;
  height: number;
  name: string;
  logo: ApiFilestackImageData | null;
};

export function SearchHitImageLogo({ width, height, name, logo }: Props) {
  if (logo) {
    return (
      <FilestackImage
        qaId="logo-uploaded-image"
        width={width}
        height={height}
        expandSize
        objectFit="contain"
        objectPosition="center center"
        data={logo}
        alt={name}
        noCrop
      />
    );
  }

  return <Initials name={name} size={width} />;
}
